/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const pushAnnouncement = /* GraphQL */ `
  mutation PushAnnouncement($mapId: ID!, $type: String!, $value: String!) {
    pushAnnouncement(mapId: $mapId, type: $type, value: $value) {
      mapId
      type
      value
    }
  }
`;
export const createJourneyMap = /* GraphQL */ `
  mutation CreateJourneyMap(
    $input: CreateJourneyMapInput!
    $condition: ModelJourneyMapConditionInput
  ) {
    createJourneyMap(input: $input, condition: $condition) {
      id
      owner
      title
      version
      preview
      updatedAt
      createdAt
      collaborators {
        items {
          mapId
          user
          type
          createdAt
        }
        nextToken
      }
    }
  }
`;
export const updateJourneyMap = /* GraphQL */ `
  mutation UpdateJourneyMap(
    $input: UpdateJourneyMapInput!
    $condition: ModelJourneyMapConditionInput
  ) {
    updateJourneyMap(input: $input, condition: $condition) {
      id
      owner
      title
      version
      preview
      updatedAt
      createdAt
      collaborators {
        items {
          mapId
          user
          type
          createdAt
        }
        nextToken
      }
    }
  }
`;
export const deleteJourneyMap = /* GraphQL */ `
  mutation DeleteJourneyMap(
    $input: DeleteJourneyMapInput!
    $condition: ModelJourneyMapConditionInput
  ) {
    deleteJourneyMap(input: $input, condition: $condition) {
      id
      owner
      title
      version
      preview
      updatedAt
      createdAt
      collaborators {
        items {
          mapId
          user
          type
          createdAt
        }
        nextToken
      }
    }
  }
`;
export const createMapOperation = /* GraphQL */ `
  mutation CreateMapOperation(
    $input: CreateMapOperationInput!
    $condition: ModelMapOperationConditionInput
  ) {
    createMapOperation(input: $input, condition: $condition) {
      id
      owner
      mapId
      type
      data
      createdAt
      updatedAt
    }
  }
`;
export const deleteMapOperation = /* GraphQL */ `
  mutation DeleteMapOperation(
    $input: DeleteMapOperationInput!
    $condition: ModelMapOperationConditionInput
  ) {
    deleteMapOperation(input: $input, condition: $condition) {
      id
      owner
      mapId
      type
      data
      createdAt
      updatedAt
    }
  }
`;
export const createJourneyMapOperation = /* GraphQL */ `
  mutation CreateJourneyMapOperation(
    $input: CreateJourneyMapOperationInput!
    $condition: ModelJourneyMapOperationConditionInput
  ) {
    createJourneyMapOperation(input: $input, condition: $condition) {
      mapId
      seq
      owner
      type
      data
      createdAt
    }
  }
`;
export const deleteJourneyMapOperation = /* GraphQL */ `
  mutation DeleteJourneyMapOperation(
    $input: DeleteJourneyMapOperationInput!
    $condition: ModelJourneyMapOperationConditionInput
  ) {
    deleteJourneyMapOperation(input: $input, condition: $condition) {
      mapId
      seq
      owner
      type
      data
      createdAt
    }
  }
`;
export const createJourneyMapCollaborator = /* GraphQL */ `
  mutation CreateJourneyMapCollaborator(
    $input: CreateJourneyMapCollaboratorInput!
    $condition: ModelJourneyMapCollaboratorConditionInput
  ) {
    createJourneyMapCollaborator(input: $input, condition: $condition) {
      mapId
      user
      type
      createdAt
      map {
        id
        owner
        title
        version
        preview
        updatedAt
        createdAt
        collaborators {
          nextToken
        }
      }
    }
  }
`;
export const updateJourneyMapCollaborator = /* GraphQL */ `
  mutation UpdateJourneyMapCollaborator(
    $input: UpdateJourneyMapCollaboratorInput!
    $condition: ModelJourneyMapCollaboratorConditionInput
  ) {
    updateJourneyMapCollaborator(input: $input, condition: $condition) {
      mapId
      user
      type
      createdAt
      map {
        id
        owner
        title
        version
        preview
        updatedAt
        createdAt
        collaborators {
          nextToken
        }
      }
    }
  }
`;
export const deleteJourneyMapCollaborator = /* GraphQL */ `
  mutation DeleteJourneyMapCollaborator(
    $input: DeleteJourneyMapCollaboratorInput!
    $condition: ModelJourneyMapCollaboratorConditionInput
  ) {
    deleteJourneyMapCollaborator(input: $input, condition: $condition) {
      mapId
      user
      type
      createdAt
      map {
        id
        owner
        title
        version
        preview
        updatedAt
        createdAt
        collaborators {
          nextToken
        }
      }
    }
  }
`;
export const updateMap = /* GraphQL */ `
  mutation UpdateMap($mapId: ID!, $title: String, $preview: String) {
    updateMap(mapId: $mapId, title: $title, preview: $preview) {
      id
      owner
      title
      version
      preview
      updatedAt
      createdAt
      collaborators {
        items {
          mapId
          user
          type
          createdAt
        }
        nextToken
      }
    }
  }
`;
export const addJourneyMapOperation = /* GraphQL */ `
  mutation AddJourneyMapOperation($mapId: ID!, $type: String!, $data: String!) {
    addJourneyMapOperation(mapId: $mapId, type: $type, data: $data) {
      mapId
      seq
      owner
      type
      data
      createdAt
    }
  }
`;
export const deleteJourneyMapOperations = /* GraphQL */ `
  mutation DeleteJourneyMapOperations($mapId: ID!, $seqList: [Int]!) {
    deleteJourneyMapOperations(mapId: $mapId, seqList: $seqList)
  }
`;
export const applyCollaborators = /* GraphQL */ `
  mutation ApplyCollaborators(
    $mapId: ID!
    $collaborators: [CollaboratorInput]!
  ) {
    applyCollaborators(mapId: $mapId, collaborators: $collaborators)
  }
`;
export const revokeMapAccess = /* GraphQL */ `
  mutation RevokeMapAccess($mapId: ID!) {
    revokeMapAccess(mapId: $mapId)
  }
`;
